import { createContext, useContext } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { DraggableAttributes } from "@dnd-kit/core";
import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";

interface SortableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  "data-row-key": string;
}

const DragHandleContext = createContext<{
  attributes: DraggableAttributes;
  listeners: SyntheticListenerMap | undefined;
}>({
  attributes: {} as DraggableAttributes,
  listeners: undefined,
});

export const SortableRow = ({
  "data-row-key": id,
  ...props
}: SortableRowProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Transform.toString(transform),
    transition,
    ...(isDragging ? { position: "relative", zIndex: 2, opacity: 0.8 } : {}),
  };

  return (
    <DragHandleContext.Provider value={{ attributes, listeners }}>
      <tr {...props} {...attributes} ref={setNodeRef} style={style} />
    </DragHandleContext.Provider>
  );
};

export const useDragHandle = () => {
  return useContext(DragHandleContext);
};
